/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function registerHideOnClickOutsideEventListener(_ref) {
  var getRootNode = _ref.getRootNode,
      onHide = _ref.onHide;

  var eventHandler = function eventHandler(event) {
    var node = event.target;
    var rootNode = getRootNode();

    if (!rootNode) {
      return;
    }

    if (!global.document.body.contains(node)) {
      return;
    }

    if (rootNode !== node && !rootNode.contains(node)) {
      onHide(event, {
        target: null
      });
    }
  };

  global.document.addEventListener('click', eventHandler);

  var unregister = function unregister() {
    global.document.addEventListener('click', eventHandler);
  };

  return unregister;
}

var _default = registerHideOnClickOutsideEventListener;
exports.default = _default;